import {
  HttpContextToken,
  HttpErrorResponse,
  HttpInterceptorFn,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, switchMap, throwError } from 'rxjs';
import { AuthService } from '../services/api/auth.service';

const RETRY_WITH_REFRESH = new HttpContextToken<boolean>(() => false);

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status !== 401) {
        return throwError(() => error);
      }

      if (
        req.url.includes('/admin/auth/login') ||
        req.url.includes('/public/')
      ) {
        return throwError(() => error);
      }

      if (
        req.url.includes('/admin/auth/refresh') ||
        req.context.get(RETRY_WITH_REFRESH) ||
        !auth.hasRefreshToken()
      ) {
        auth.logout();
        return throwError(() => error);
      }

      return auth.refreshSession().pipe(
        switchMap((accessToken) =>
          next(
            req.clone({
              context: req.context.set(RETRY_WITH_REFRESH, true),
              setHeaders: { Authorization: `Bearer ${accessToken}` },
            }),
          ),
        ),
        catchError((refreshError) => {
          auth.logout();
          return throwError(() => refreshError);
        }),
      );
    }),
  );
};
